export default function hasToValidateRole(role) {
  try {
    return role?.length > 0 && role.includes('developer');
  } catch (error) {
    return false;
  }
}
